module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "120px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("“Marriott knows how to delve into the mire, unearth the evidence and reconstruct the history of this murky affair… harrowing to read but we dare not turn away.” ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("The Rt Hon Dr Julian Lewis MP ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "font-style": "italic"
    }
  }, [_vm._v("“What’s happening? Marriott leaves us wondering how the\nsenior military command expect us to trust them to organize\nanything, if all the post and emails to them on issues like this\nsomehow get lost, or they are prepared to lie so blatantly.”")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Dr David Healy, ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("MD FRCPsych, Professor of Family Medicine, McMaster ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("University, Hamilton, Canada. ")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "font-style": "italic"
    }
  }, [_vm._v("“A veritable tour de force. An indictment of the nightmarish \nhistory of mefloquine's development.” ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Dr Remington Nevin, MD, MPH, DrPH, "), _c('br'), _vm._v("\nThe Quinism Foundation ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 63
// module chunks = 0